import { render, staticRenderFns } from "./ConversationColorHelp.vue?vue&type=template&id=b08a4f98"
import script from "./ConversationColorHelp.vue?vue&type=script&lang=js"
export * from "./ConversationColorHelp.vue?vue&type=script&lang=js"
import style0 from "./ConversationColorHelp.vue?vue&type=style&index=0&id=b08a4f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports